import { ProductForm } from 'components/goods/ProductForm/ProductForm'

export const GoodsEdit: React.FC = () => {
  return <ProductForm mode='edit' />
}
